export const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Notes', value: 'notes' },
  { label: 'Contacts', value: 'contacts' },
]
